var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPinStencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "yz7nu175ta",
    d: "M0 0.228L15.878 0.228 15.878 22.549 0 22.549z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.94 10.469c-1.296 0-2.35-1.04-2.35-2.317 0-1.278 1.054-2.317 2.35-2.317 1.294 0 2.347 1.04 2.347 2.317 0 1.277-1.053 2.317-2.348 2.317m0-5.536c-1.8 0-3.263 1.444-3.263 3.22 0 1.774 1.464 3.218 3.263 3.218s3.263-1.444 3.263-3.219-1.464-3.219-3.263-3.219",
    transform: "translate(-479 -307) translate(479 307)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-479 -307) translate(479 307) translate(0 .223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lzfd2qz21b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yz7nu175ta"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.94 21.052C6.451 19.064.913 11.434.913 8.06c0-3.822 3.152-6.93 7.025-6.93s7.025 3.108 7.025 6.93c0 3.374-5.538 11.004-7.025 12.992m0-20.824C3.561.228 0 3.74 0 8.06c0 4.18 7.267 13.62 7.577 14.02l.363.47.363-.47c.31-.4 7.576-9.84 7.576-14.02 0-4.319-3.561-7.832-7.939-7.832",
    mask: "url(#lzfd2qz21b)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinStencil);
export default __webpack_public_path__ + "static/media/ic-pin-stencil.6301d773c4870b9ac47aea0ad8734bc7.svg";
export { ForwardRef as ReactComponent };